import {PageTitle} from '../../../../../_metronic/layout/core';
import HasPermission from '../../../auth/HasPermission';
import CountersWidget from './components/CountersChartWidget';
import LoginSessionTable from './components/LoginSessionTable';
import LoginSessionsWidget from './components/LoginSessionsWidget';
import ServersRunTimeSummaryChart from './components/ServersRunTimeChart';
import ModelsCountWidget from './components/ModelsCountWidget';
import TotalModelsWidget from './components/TotalModelsWidget';
import UsersCountWidget from './components/UsersCountWidget';
import {useAuth} from '../../../auth';

export const AdminOverviewPage = () => {
  const {currentUser} = useAuth();
  return (
    <>
      <PageTitle breadcrumbs={[{title: 'User Dashboard', path: '/', isActive: true}]}>
        Overview
      </PageTitle>

      <div className='row container-fluid mx-auto'>
        <HasPermission code='admin-widgets.models-counters-by-status'>
          <div className='col-lg-6 col-xxl-4'>
            <ModelsCountWidget />
          </div>
        </HasPermission>

        <div className='col-lg-8 col-xxl-7'>
          <HasPermission code='admin-widgets.total-models-users-counters'>
            <div className='row'>
              <div className='col-md-6'>
                <UsersCountWidget />
              </div>

              <div className='col-md-6'>
                <TotalModelsWidget />
              </div>
            </div>
          </HasPermission>

          <HasPermission code='admin-widgets.models-statistics-chart'>
            <CountersWidget />
          </HasPermission>
        </div>

        {/* <div className='col-lg-5 col-xl-4'>
          <UsersCountWidget />
        </div> */}
      </div>
      <div className='row container-fluid mx-auto'>
        {currentUser?.is_super_admin && (
          <div className='col-lg-12 col-xxl-11'>
            <ServersRunTimeSummaryChart />
          </div>
        )}
      </div>
    </>
  );
};
